export enum ModifierGroupTypeEnum {
  Regular = 0,
  Tab = 1, // Size
  Quantity = 2,
  Scroll = 3,
  Image = 4,
  Custom = 5
}